import { finalize, Observable, share } from 'rxjs';

export class ObservableDictionary<T> {
  private readonly objectMap: Record<string, Observable<T>> = {};
  private readonly create: (key: string) => Observable<T>;
  private readonly destroy: (key: string) => void;

  constructor(
    create: (key: string) => Observable<T>,
    destroy: (key: string) => void,
  ) {
    this.destroy = destroy;
    this.create = create;
  }

  onFinalize(key: string): void {
    delete this.objectMap[key];
    this.destroy(key);
  }

  getOrAdd(key: string): Observable<T> {
    if (!this.objectMap[key]) {
      const channel$ = this.create(key);
      this.objectMap[key] = channel$.pipe(
        finalize(() => this.onFinalize(key)),
        share(),
      );
    }

    return this.objectMap[key];
  }
}
